import React, { useState, useEffect, useContext } from "react";
import { Col } from "reactstrap";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useLocation, useParams } from "react-router";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Radio } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import StripeElement from "./StripeElement";
import moment from "moment-timezone";
import { MyContext } from "../App";
import { Link, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

import SimpleForm from "./simpleForm";
import SimpleFormText from "./simpleFormText";
import ScrollToTop from "../Blog/ScrollToTop";
import Popup from "../Popup/Popup";
import "./calendar.css";
import "../Appointment/AppointmentPage.css";

// import moment from "moment";
const YellowRadio = withStyles({
  root: {
    color: "#D3A625",
    "&$checked": {
      color: "#D3A625",
    },
  },
  checked: {},
})((props) => <Radio color='default' {...props} />);

const useStyles = makeStyles({
  container: {
    margin: "20px",
    width: "100%",
    // padding: "20px",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // width: "60%",
    "@media (max-width: 1050px)": {
      // marginLeft: "0.5rem",
      width: "100%",
    },
  },

  content2: {
    fontSize: "20px",
    // fontFamily: "SFProDisplayRegular",
    color: "#D3A625",
    textAlign: "left",
  },

  selectTime2: {
    fontSize: "38px",
    color: "#D3A625",
    fontFamily: "Hoefler Text",
    margin: "0 auto",
    textAlign: "center",
  },

  bookButton: {
    width: "200px",
    height: "50px",
    cursor: "pointer",
    backgroundColor: "#D3A625",
    border: "2px solid #D3A625",
    color: "white",
    // padding: "0 10px 0 10px",
    textDecoration: "none",
    fontSize: "20px",
    borderRadius: "50px",
    fontFamily: "AvenirHeavy",
    "&:hover": {
      borderColor: "#D3A625",
      background: "#D3A625",
      color: "#white",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    "&:active": {
      outline: "none",
      boxShadow: "none",
    },
    "&:disabled": {
      backgroundColor: "#D3A625",
      color: "white",
      opacity: "50%",
      "&:hover": {
        borderColor: "#D3A625",
      },
    },
  },

  timeslotButton: {
    width: "10rem",
    height: "3rem",
    maxWidth: "80%",
    backgroundColor: "white",
    border: "2px solid #D3A625",
    color: "#D3A625",
    // padding: "15px 90px",
    textAlign: "center",
    textDecoration: "none",
    fontSize: "20px",
    borderRadius: "50px",
    display: "block",
    margin: "6px auto",
    "&:hover": {
      background: "#D3A625",
      color: "white",
    },
    "&:focus": {
      background: "#D3A625",
      color: "white",
      outline: "none",
      boxShadow: "none",
    },
    "&:active": {
      background: "#D3A625",
      color: "white",
      outline: "none",
      boxShadow: "none",
    },
  },

  img: {
    width: "320px",
    "@media (max-width: 1050px)": {
      width: "280px",
    },
  },
});
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URI;
const AUXP_URL = process.env.REACT_APP_SERVER_AUXP_URI;
export default function AppointmentPage(props) {
  const classes = useStyles();
  const location = useLocation();
  // moment().format();
  console.log("(AppointmentPageConfirm) props: ", props);
  //strip use states
  const access_token = location.state.accessToken;
  console.log("(AppointmentPageConfirm) accessToken: ", access_token);
  const totalCost = "$" + location.state.totalCost;
  const totalDuration = location.state.totalDuration;
  const durationText = location.state.durationText;
  console.log(totalDuration);

  const { treatmentID } = useParams();
  const [stripePromise, setStripePromise] = useState(null);
  const [useTestKeys, setUseTestKeys] = useState(true);
  const [stripeKeyLast4, setStripeKeyLast4] = useState(null);

  // form use states, Axios.Post
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [notes, setNotes] = useState("");
  const [gender, setGender] = useState({
    male: false,
    female: true,
  });
  const [selectGender, setSelectGender] = useState("Female");
  const [age, setAge] = useState("");

  // for hide & show
  const [infoSubmitted, setInfoSubmitted] = useState(false);
  // const [bookNowClicked, setBookNowClicked] = useState(false);
  const [bookNowClicked, setBookNowClicked] = useState(true);
  //import context
  const { serviceArr, servicesLoaded } = useContext(MyContext);
  const [elementToBeRendered, setElementToBeRendered] = useState([]);
  const treatment_uid = treatmentID;
  //for axios.get
  const [customerUid, setCustomerUid] = useState("");
  const cost = elementToBeRendered.cost;
  const [errorMessage, setErrorMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [dialogText, setDialogText] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  // console.log("Cost", totalCost);
  // console.log("Cost",cost);

  useEffect(() => {
    if (servicesLoaded) {
      serviceArr.forEach((element) => {
        if (element.treatment_uid === treatment_uid) {
          setElementToBeRendered(element);
          console.log("element to be rendered: ", elementToBeRendered);
          console.log("duration: ", elementToBeRendered.duration);
        }
      });
    }
  });
  const required =
    errorMessage === "Please fill out all fields" ? (
      <span className='ms-1' style={{ color: "red", fontSize: "12px" }}>
        *
      </span>
    ) : (
      ""
    );
  // parse duration
  const parseDuration = (rawDuration) => {
    if (rawDuration === undefined) {
      return "";
    }
    console.log("rawDuration: ", rawDuration);
    let parsedDuration = "";

    let durationTokens = rawDuration.split(":");
    console.log("durationTokens: ", durationTokens);

    if (Number(durationTokens[0]) > 0) {
      parsedDuration = parsedDuration + durationTokens[0] + " hr ";
    }

    let minsNum = Number(durationTokens[1]);
    let secsNum = Number(durationTokens[2]);

    if (secsNum >= 31) {
      minsNum++;
    }

    parsedDuration = parsedDuration + minsNum + " min";

    return parsedDuration;
  };
  const handleGender = (event) => {
    var optionPick = event.target.name;
    console.log(optionPick);
    var newGenderObj = {};
    var newGender = "";
    if (optionPick === "female") {
      newGenderObj = {
        male: false,
        female: true,
      };
      newGender = "Female";
    } else {
      newGenderObj = {
        male: true,
        female: false,
      };
      newGender = "Male";
    }
    console.log(newGenderObj);
    setGender(newGenderObj);
    setSelectGender(newGender);
  };
  // handle form changes
  const handleAgeChange = (newAge) => {
    setAge(newAge.target.value);
  };
  const handleFirstNameChange = (newFName) => {
    setFirstName(newFName.target.value);
  };

  const handleLastNameChange = (newLName) => {
    setLastName(newLName.target.value);
  };

  const handleEmailChange = (newEmail) => {
    setEmail(newEmail.target.value);
  };

  const handlePhoneNumChange = (newPhoneNum) => {
    setPhoneNum(newPhoneNum.target.value);
  };

  const handleNotesChange = (newNotes) => {
    setNotes(newNotes.target.value);
  };

  //for stripe
  async function toggleKeys() {
    console.log(age);

    // Force refresh of Stripe credentials from API on every "Book Appointment" click
    console.log("🚀 Book Appointment clicked - Forcing fresh Stripe credentials from API...");

    if (age === "" || email === "" || firstName === "" || lastName === "" || phoneNum === "") {
      setErrorMessage("Please fill out all fields");
      return;
    }

    if (email !== 0) {
      if (!email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        setErrorMessage("Please enter a valid email.");
        return;
      }
    }

    const body = {
      first_name: firstName,
      last_name: lastName,
      role: "CUSTOMER",
      phone_num: phoneNum.replace(/[^a-z\d\s]+/gi, ""),
      email: email,
      is_ret_client_appt: ["330-000005", "330-000006"].includes(treatmentID),
    };
    // sendToDatabase();
    try {
      const resp = await axios.post(BASE_URL + "findCustomer", body);
      if (resp.data.customer_uid) setCustomerUid(resp.data.customer_uid);
      if (resp.data.warning) {
        setDialogTitle("Warning");
        setDialogText(resp.data.warning);
        setShowDialog(true);
      }
    } catch (error) {
      setDialogTitle("Error");
      setDialogText(error.response.data.message);
      setShowDialog(true);
      return;
    }

    console.log("response", customerUid);
    if (notes === "NITYATEST") {
      // Fetch public key
      console.log("🔄 Fetching fresh Stripe TEST credentials from API...");
      axios
        .get(AUXP_URL + "stripe_key/NITYATEST")
        .then((result) => {
          console.log("(1 PaymentDetails) Stripe-key then result (1): " + JSON.stringify(result));
          console.log("🔍 Full API Response:", result);
          console.log("🔍 result.data:", result.data);
          console.log("🔍 result.data.publicKey:", result.data.publicKey);
          console.log("🔍 typeof result.data.publicKey:", typeof result.data.publicKey);
          console.log("🔍 result.data.publicKey length:", result.data.publicKey ? result.data.publicKey.length : "N/A");

          // Log last 4 digits of Stripe key for verification
          const stripeKey = result.data.publicKey;
          const last4Digits = stripeKey ? stripeKey.slice(-4) : "N/A";
          setStripeKeyLast4(last4Digits);
          console.log("🔑 Stripe TEST Key (last 4 digits):", last4Digits);
          console.log("🔑 Full Stripe TEST Key:", stripeKey);

          let tempStripePromise = loadStripe(result.data.publicKey);

          console.log("(1 PaymentDetails) setting state with stripePromise");

          setStripePromise(tempStripePromise);

          console.log(tempStripePromise);
          console.log("(1 PaymentDetails) stripePromise set!");
        })
        .catch((err) => {
          console.log(err);
          if (err.response) {
            console.log("(1 PaymentDetails) error: " + JSON.stringify(err.response));
          }
        });
    } else {
      // Fetch public key live
      console.log("🔄 Fetching fresh Stripe LIVE credentials from API...");
      axios
        .get(AUXP_URL + "stripe_key/NITYA")
        .then((result) => {
          console.log("(2 PaymentDetails) Stripe-key then result (1): " + JSON.stringify(result));
          console.log("🔍 Full API Response:", result);
          console.log("🔍 result.data:", result.data);
          console.log("🔍 result.data.publicKey:", result.data.publicKey);
          console.log("🔍 typeof result.data.publicKey:", typeof result.data.publicKey);
          console.log("🔍 result.data.publicKey length:", result.data.publicKey ? result.data.publicKey.length : "N/A");

          // Log last 4 digits of Stripe key for verification
          const stripeKey = result.data.publicKey;
          const last4Digits = stripeKey ? stripeKey.slice(-4) : "N/A";
          setStripeKeyLast4(last4Digits);
          console.log("🔑 Stripe LIVE Key (last 4 digits):", last4Digits);
          console.log("🔑 Full Stripe LIVE Key:", stripeKey);

          let tempStripePromise = loadStripe(result.data.publicKey);

          console.log("(2 PaymentDetails) setting state with stripePromise");

          console.log(tempStripePromise);
          setStripePromise(tempStripePromise);

          console.log("(2 PaymentDetails) stripePromise set!");
        })
        .catch((err) => {
          console.log(err);
          if (err.response) {
            console.log("(2 PaymentDetails) error: " + JSON.stringify(err.response));
          }
        });
    }
    setUseTestKeys(!useTestKeys);
    setErrorMessage("");
    setInfoSubmitted(true);
  }

  // Convert Pacific Time to user's local timezone with timezone info
  const convertToUserTimezoneWithInfo = (date, time) => {
    try {
      // Create a date object in Pacific Time
      const pacificTime = moment.tz(`${date} ${time}`, "America/Los_Angeles");

      // Convert to user's local timezone
      const userTime = pacificTime.tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

      // Format as 12-hour time
      const formattedTime = userTime.format("h:mm A");

      // Get timezone abbreviation
      const timezoneAbbr = userTime.format("z");

      return {
        time: formattedTime,
        timezone: timezoneAbbr,
      };
    } catch (error) {
      console.error("Error converting timezone:", error);
      // Fallback to original format if conversion fails
      return {
        time: formatTime(date, time),
        timezone: "PST",
      };
    }
  };

  function formatTime(date, time) {
    if (time == null) {
      return "?";
    } else {
      console.log(date, time);
      var newDate = new Date((date + "T" + time).replace(/\s/, "T"));
      var hours = newDate.getHours();
      var minutes = newDate.getMinutes();
      console.log(hours, minutes);
      var ampm = hours >= 12 ? "pm" : "am";
      console.log(ampm);
      hours = hours % 12;
      console.log(hours);
      hours = hours ? hours : 12; // the hour '0' should be '12'
      console.log(hours);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      console.log(minutes);
      var strTime = hours + ":" + minutes + " " + ampm;
      console.log(strTime);
      return strTime;
    }
  }

  const handleDialogClose = () => {
    setShowDialog(false);
  };

  return (
    <div className='HomeContainer'>
      <ScrollToTop />
      <Popup showDialog={showDialog} onClose={handleDialogClose} title={dialogTitle} text={dialogText} />
      <br />
      {bookNowClicked || location.state.signedin ? (
        <div className='Card' style={{ alignItems: "center" }}>
          <div className={classes.container}>
            <div>
              <div>
                <div className={classes.selectTime2}>
                  <div className='TitleFontAppt'>Appointment scheduled for:</div>
                </div>
                <br></br>

                <h1
                  style={{
                    fontSize: "30px",
                    margin: "0 auto",
                    textAlign: "center",
                  }}
                >
                  <span>
                    {(() => {
                      const timeInfo = convertToUserTimezoneWithInfo(location.state.date, location.state.time);
                      return `${moment(location.state.date).format("ll")} at ${timeInfo.time} ${timeInfo.timezone} - ${location.state.mode}`;
                    })()}
                  </span>
                </h1>
              </div>
            </div>
            <br />
            <div className='ApptConfirmContainer'>
              <div>
                <p className={classes.content2} style={{ textAlign: "left" }}>
                  <span
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    {elementToBeRendered.title}
                  </span>
                  <br />
                  {durationText} | {totalCost}
                </p>
                <img src={elementToBeRendered.image_url} className={classes.img} style={{ objectFit: "cover", textAlign: "left" }} alt='' />
                <br />
                <br />

                {/* Conditional content based on appointment mode */}
                {location.state.mode === "In-Person" ? (
                  <div>
                    <p className={classes.content2} style={{ textAlign: "left" }}>
                      1610 Blossom Hill Rd, Ste #1
                      <br />
                      San Jose, CA, 95124
                      <br />
                      <br />
                      Office: (408) 471-7004
                    </p>
                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                      <iframe
                        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.4933191234104!2d-121.90686878683185!3d37.23600137200993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808e36ab01586fa9%3A0xe80e7882881a56a0!2s1610%20Blossom%20Hill%20Rd%20%231%2C%20San%20Jose%2C%20CA%2095124!5e0!3m2!1sen!2sus!4v1714712803119!5m2!1sen!2sus'
                        width='100%'
                        height='300'
                        style={{ border: "0", borderRadius: "10px" }}
                        allowFullScreen=''
                        loading='lazy'
                        referrerPolicy='no-referrer-when-downgrade'
                        title='Nitya Ayurveda Location'
                      ></iframe>
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <p className={classes.content2} style={{ fontSize: "24px", fontWeight: "600", color: "#D3A625", marginBottom: "15px" }}>
                      We'll see you Online
                    </p>
                    <p className={classes.content2} style={{ fontSize: "18px", lineHeight: "1.6" }}>
                      We'll send a link out 5 min before the meeting.
                    </p>
                  </div>
                )}
              </div>
              <div className='ApptConfirmTextBox'>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                  }}
                >
                  {firstName === "" ? required : ""}
                  <input
                    name='variable'
                    placeholder='Enter First Name'
                    value={firstName}
                    onChange={handleFirstNameChange}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                  {required ? "" : <span>&nbsp;</span>}
                  {lastName === "" ? required : ""}
                  <input
                    name='variable'
                    placeholder='Enter Last Name'
                    value={lastName}
                    onChange={handleLastNameChange}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <FormControlLabel control={<YellowRadio checked={gender.female} onChange={(e) => handleGender(e)} name='female' />} label='Female' />
                  <FormControlLabel control={<YellowRadio checked={gender.male} onChange={(e) => handleGender(e)} name='male' />} label='Male' />
                  {/* <SimpleForm field="Age" onHandleChange={handleAgeChange} /> */}
                  {age === "" ? required : ""}
                  <input
                    name='variable'
                    placeholder='Age'
                    value={age}
                    onChange={(e) => handleAgeChange(e)}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                  }}
                ></div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                  }}
                >
                  {/* <SimpleForm
                    field="Email Address"
                    onHandleChange={handleEmailChange}
                  /> */}
                  {email === "" ? required : ""}
                  <input
                    name='variable'
                    placeholder='Email Address'
                    value={email}
                    // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    onChange={(e) => handleEmailChange(e)}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                  }}
                >
                  {/* <SimpleForm
                    field="Phone Number - 10 digits only"
                    maxLength="10"
                    onHandleChange={handlePhoneNumChange}
                  /> */}
                  {phoneNum === "" ? required : ""}
                  <input
                    name='variable'
                    placeholder='Phone Number - 10 digits only'
                    value={phoneNum}
                    maxLength='10'
                    onChange={(e) => handlePhoneNumChange(e)}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                </div>

                <div
                  style={{
                    marginBottom: "10px",
                  }}
                >
                  {/* <SimpleFormText
                    field="Type your message here"
                    onHandleChange={handleNotesChange}
                  /> */}
                  <input
                    name='variable'
                    placeholder='Type your message here'
                    value={notes}
                    maxLength='100'
                    onChange={(e) => handleNotesChange(e)}
                    style={{
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "20px",
                      fontColor: "black",
                      fontSize: "20px",
                      border: "2px solid #B28D42",
                      width: "100%",
                      // fontFamily: "AvenirHeavy",
                      outline: "none",
                    }}
                  />
                </div>
                <div
                  hidden={!infoSubmitted}
                  style={{
                    background: "white",
                  }}
                >
                  {stripeKeyLast4 && (
                    <div
                      style={{
                        textAlign: "center",
                        marginBottom: "10px",
                        padding: "8px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      🔑 Using Stripe Key ending in: {stripeKeyLast4}
                    </div>
                  )}
                  <StripeElement
                    accessToken={access_token}
                    customerUid={customerUid}
                    stripePromise={stripePromise}
                    treatmentID={treatmentID}
                    treatmentName={elementToBeRendered.title}
                    notes={notes}
                    infoSubmitted={infoSubmitted}
                    firstName={firstName}
                    lastName={lastName}
                    email={email}
                    phoneNum={phoneNum}
                    date={moment(location.state.date).format("ll")}
                    selectedTime={formatTime(location.state.date, location.state.time)}
                    mode={location.state.mode}
                    age={age}
                    gender={selectGender}
                    purchaseDate={purchaseDate}
                    cost={totalCost}
                    treatmentDate={location.state.date}
                    treatmentTime={location.state.time}
                    duration={totalDuration}
                    image_url={elementToBeRendered.image_url}
                  />
                </div>
                <div className='text-center' style={errorMessage === "" ? { visibility: "hidden" } : {}}>
                  <p style={{ color: "red", fontSize: "12px" }}>{errorMessage || "error"}</p>
                </div>
                <div
                  aria-label={"click button to book your appointment"}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Link to={{ pathname: "/waiver" }} className='nav-link'>
                    {/* <button
                  className={classes.bookButton}
                  variant="contained"
                  component="span"
                  type="button"
                  // onClick={onImageUpload}
                >
                  Waiver
                </button> */}
                  </Link>
                </div>
                <div
                  aria-label={"click button to book your appointment"}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button className={classes.bookButton} hidden={infoSubmitted} onClick={toggleKeys}>
                    Book Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <br />
      <br />
    </div>
  );
}

/**
 * Things to work on
 *
 * 1. The axios call happens everytime a new date is clicked on the calendar. That's overkill.
 * Instead figure out a way to load the information retrieved from the endpoint into an array.
 *
 * 2.Figure out how to ensure that when the apptPage is loaded up, that the current date is initialy selected.
 * As of the momment, when the page loads, it holds "00/00/0000" as the selected date.
 *
 * 3.Prior to rendering the appointment page
 */
